module.exports = "/_next/static/images/54435f43724bb99f6b03315d56841ac4-digital-account-phone-main-screen@md-2x.png";